import {api,imgPath} from "../../../common/config";
import {ajaxUtil} from "../../../common/AjaxUtil.js";
import {store} from '../../../store/store.js';
import $ from 'jquery'
import LoginMask from '../../../components/loginmask.vue';
import QRCode from 'qrcodejs2'

export default {
  name: 'bookinfo',
  components: {
      LoginMask
  },
  data() {
    return {
      id: 0,
      book: {},
      library: {
        libCode:""
      },
      chooseNav: 1,
      imgError: store.imgError,
      isCollect: false,
      opacType: store.opacType,
      favorStatus: 0,  // 1已收藏，0未收藏
      isReader:false,//是否成为该馆读者
      imgPath:imgPath,
      currHallCodeExist: -1,  //0 不存在  1 存在
      webType:0,
      nearbyLibraryName:0
    }
  },

  beforeMount() {
    store.wrap.activeRouteName = '电子书';
    this.id = this.$route.query.id || '';
    let hallCode = this.$route.query.hallCode || this.$route.query.libCode || '';
    this.webType= store.webType
    var url = api.ebook.info.replace('{id}', this.id).replace('{hallCode}',hallCode); //电子书详情
    var url1 = api.ebook.belongLibrary.replace('{ebookId}', this.id).replace('{lngLat}', store.localtionArea.latLng).replace('{readerId}', "");
    ajaxUtil.ajaxJson(url, null, "GET", (data) => {
        this.currHallCodeExist=data.currHallCodeExist
        this.nearbyLibraryName=data.nearbyLibraryName
      this.book = data || {extraInfo: {borrowNum: 0}, id: ""};
      let shareArr = [];
      if(this.opacType == 0){
          shareArr=['weixin', 'sqq', 'qzone', 'tsina'];
          this.shareBtn(shareArr);
      }else{
          shareArr=['weixin'];
          this.shareBtn(shareArr);
      }
    }, null, this);
    //电子书所属图书馆
      if(hallCode){
        ajaxUtil.ajaxJson(api.getLibrary.info.replace('{hallCode}',hallCode),null,"GET",(data)=>{
          if(data== null){
            return ;
          }else{
            this.library=data;
            this.getEbookQrCode();
          }
        },null,this);
      }else{
          ajaxUtil.ajaxJson(url1, null, "GET", (data) => {
              if(data==null){
              return
          }else{
              this.library = data;
              this.getEbookQrCode();

          }
      }, null, this);
      }

  },
  beforeRouteLeave(to, from, next) {
    if ($('#bdshare_weixin_qrcode_dialog')) {/*关闭分享组件微信分享页面*/
      $('#bdshare_weixin_qrcode_dialog').hide();
    }
    next()
  },
  mounted() {
    if (store.user.idCard != null && store.user.idCard != undefined) {
        this.getCollectStatus();
    }
  },
  methods: {
     hidden(){
       this.isReader = false;
     },
    //设置收藏状态
      getCollectStatus(){
        var _this = this;
        var bookCollectionStatusUrl = api.ebook.collectionStatus.replace('{ebookId}', this.id).replace('{readerId}', store.user.readerId);
        ajaxUtil.ajaxJson(bookCollectionStatusUrl, null, "GET", function (data) {
            if (data.favorStatus == 1) {
                _this.isCollect = true;
            } else {
                _this.isCollect = false;
            }
        }, null, this);
    },
    shareBtn(shareArr) {
      window._bd_share_config = {
        share: [{
          "tag": "share_book",
          "bdSize": 16,
          "bdCustomStyle": require('./sharebtn.sass')
        }],
        common: {
          bdText: '云图书馆' + ' - ' + this.book.bookName,
          bdDesc: this.book.summary ? this.book.summary.replace(/<[^>]+>/g, "").replace(/&nbsp;/ig, "") : '',//去掉html标签和空格
          bdUrl: this.book.htmlUrl,
          bdPic: this.imgPath + this.book.image || "../../../assets/noimg.png",
          bdMini: 1,
          bdMiniList: shareArr,
          bdPopupOffsetLeft: -73,
          bdPopupOffsetTop: 5,
        }
      }
      window._bd_share_main.init()
    },
    /*在线阅读*/
    readEbook() {
      //如果登录成功，点击开始阅读，检查是否是本馆读者
      if (store.user.idCard != null && store.user.idCard != undefined) {
        let url = api.reader.checkReaderEbook.replace('{hallCode}',this.library.libCode)
            .replace('{readerId}',store.user.readerId)+"?ebookId="+this.book.id;
        ajaxUtil.ajaxJson(url,null,'GET',(data)=>{
          if(data.result){//是本馆读者，直接阅读
            this.startRead(true,data.ebookIdFile);
          }else{//不是本馆读者，弹出提示框
            this.isReader=true;
          }
        },null,this);
      }else{//未登录，直接进入试读
        this.startRead(false,null);
      }
    },
    inLinbraryReader(){//成为该图书馆读者
      ajaxUtil.ajaxJson(api.reader.addReaderAuthority,{'hallCode':this.library.libCode,'readerId':store.user.readerId},'POST',(data)=>{
        //添加成功，直接去读电子书
        this.isReader = false;
        this.startRead(false,null);
      },(error)=>{
        this.isReader = false;
      },this)
    },
    //开始阅读，进入电子书阅读
    startRead(status,file){
      try{
        var i= this.book.file;
        if(status){
            i=file;
        }
           var arr=i.split('/');
        if(opac_environment.getEnvironment()==='OPAC-EPUB' || opac_environment.getEnvironment()==='OPAC'){
          this.$router.push({
            name: 'OPACEbookreading',
            query: {url: encodeURI( arr.slice(3).join('/')), id: this.id, libCode: this.library.libCode,libName:this.library.libName}
          })
        }else {
          this.$router.push({
            name: 'ebookreading',
            query: {url: encodeURI( arr.slice(3).join('/')), id: this.id, libCode: this.library.libCode,libName:this.library.libName}
          })
        }
      }catch(error) {
        this.$router.push({
          name: 'ebookreading',
          query: {url: encodeURI(  arr.slice(3).join('/')), id: this.id, libCode: this.library.libCode,libName:this.library.libName}
        })
      }
    },
    changeNav(n) {
      this.chooseNav = n;
    },
    /*电子书收藏*/
    ebookCollect() {
      if (store.user.idCard == null || store.user.idCard == undefined) {
          this.$refs.loginMask.showLogin();
          return;
      }
      if (this.isCollect) {//取消
        var data = {
          ebookIds: [this.book.id],
          readerId: store.user.readerId,
        };
        ajaxUtil.ajaxJson(api.ebook.collectionCancel, data, "post", (data) => {
          if (data.result == 1) {
            this.isCollect = !this.isCollect
          } else {
            CommonUtil.setInfo('取消收藏失败!')
          }
        }, null, this);
      } else {//收藏
        var data = {
          ebookId: this.book.id,
          readerId: store.user.readerId,
        };
        ajaxUtil.ajaxJson(api.ebook.collectionSave, data, "post", (data) => {
          if (data.result > 0) {
            this.isCollect = !this.isCollect
          } else {
            CommonUtil.setInfo('收藏失败!')
          }
        }, null, this);
      }
    },
    getEbookQrCode:function (){
      //二维码生成
      if(this.library.libCode){
        let qrCodeData="https://"+this.library.libCode.toLowerCase()+".ytsg.com/ebookinfo" +
            "?scanType=ebookDetails&id="+this.id+"&hallCode="+this.library.libCode;
        new QRCode(document.getElementById("ebookQrcodeShare"), {
          text: qrCodeData,
          width: 82,
          height: 82,
          correctLevel : 0
        });
      }
    },
    //登录弹窗
    loginSuccess: function () {
        this.getCollectStatus();
    },
  }
}

